import React from 'react';
import { InputText } from 'modules/blocks/inputs/InputText';
import _ from 'lodash';
import HttpClient from 'services/HttpClient';
import validate from 'validate.js';
import { inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

const NEWSLETTER_CONSTRAINS = {
  first_name: {
    presence: { message: 'First name is required' },
    length: {
      maximum: 20,
      tooLong: 'First name allowed only 20 symbols'
    }
  },
  last_name: {
    presence: { message: 'Last name is required' },
    length: {
      maximum: 20,
      tooLong: 'Last name allowed only 20 symbols'
    }
  },
  email: {
    presence: { message: 'Email is required' },
    email: { message: 'Email invalid' }
  }
};

const NEWSLETTER_SUBSCRIPTION = '/api/v1/newsletter_subscriptions';

@withRouter
@inject('alertStore')
export default class MailingList extends React.Component {
  state = {
    errors: {},
    formData: {
      first_name: '',
      last_name: '',
      email: ''
    }
  };

  handleChange = e => {
    const newState = _.assign({}, this.state.formData, { [e.target.name]: e.target.value });
    this.setState({ formData: newState });
  };

  submit = e => {
    e.preventDefault();
    const errors = validate(_.assign({}, this.state.formData), NEWSLETTER_CONSTRAINS, { fullMessages: false });

    if (errors) {
      this.setState({ errors });
    } else {
      this.setState({ errors: {} });
      new HttpClient().post(NEWSLETTER_SUBSCRIPTION, { newsletter_subscription: this.state.formData })
        .then(() => {
          this.props.alertStore.success('You have successfully subscribed to our mailing list!');
          this.setState({ formData: { first_name: '', last_name: '', email: '' } });
        })
        .catch(() => {
          this.props.alertStore.error('Something went wrong. Please try again.');
        });
    }
  };

  render() {
    const { errors, formData } = this.state;
    return (
      <div className="new-form-wrapper" style={{ justifyContent: 'center' }}>
        <form className="sign-in-form" style={{ marginLeft: 0, width: '50%' }} onSubmit={this.submit}>
          <h2 style={{ textAlign: 'center' }}>Join Our Mailing List</h2>
          <p className="mailing-list-description">
            Fill out the form below to subscribe to our email list and receive free content to help you pass the PRE exam
          </p>
          <div className="name-info-block">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="input-wrap">
                  <InputText
                    onChange={this.handleChange}
                    name="first_name"
                    value={formData.first_name}
                    label="First Name"
                    placeholder="Enter First Name"
                    type="text"
                    errorText={errors.first_name}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="input-wrap">
                  <InputText
                    onChange={this.handleChange}
                    name="last_name"
                    value={formData.last_name}
                    label="Last Name"
                    placeholder="Enter Last Name"
                    type="text"
                    errorText={errors.last_name}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrap">
            <InputText
              name="email"
              value={formData.email}
              onChange={this.handleChange}
              label="Email"
              placeholder="Enter Email"
              type="email"
              errorText={errors.email}
            />
          </div>
          <div className="button-set">
            <button className="btn-new-main" style={{ width: '100%' }} type="submit">
              Subscribe
            </button>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/informations/MailingList.js